<template>
    <Dialog v-model:visible="showModal" :modal="true" v-show="true" style=" max-height: 100%">
        <template #header>
            <h4 class="modal-title" id="myModalLabel">History</h4>
        </template>
        <div class="modal-body p-5">
            <ul class="timeline timeline-history">
                <li class="timeline-inverted history-li">

                    <div class="timeline-badge history-badge danger">
                        <i class="fas fa-user"></i>
                    </div>
                    <div class="row" >
                    <div class="col-12">
                        <div class="card">
                            <div class="card-body " ref="auditLogRef">
                                </div>
                                <div class="timeline-panel history-panel">
                        <div class="timeline-body">
                            <p>
                                <span class="font-weight-bold text-danger">Jhon Doe</span>
                                assigned task
                                <span class="font-weight-bold text-purple">TID01 - Creating Account</span>
                                for Visit ID
                                <span class="font-weight-bold text-success">VID02</span>
                                on DOS
                                <span class="font-weight-bold text-purple">05/26/22</span>
                                for patient
                                <span class="font-weight-bold text-danger">PT02</span>
                                -
                                <span class="font-weight-bold text-danger">Jhon Doe</span>
                            </p>
                            <p><small style="color:grey;" class="mt-2">05-26-22 01:47 AM | <span
                                        style="color:orangered">Powers Pediatrics</span> | <span
                                        style="color:orangered">Module 01</span></small></p>
                        </div>

                    </div>
                                </div>
                    </div></div>
                   
                </li>

                <li class="timeline-inverted history-li">

                    <div class="timeline-badge history-badge info">
                        <i class="fas fa-user"></i>
                    </div>

                    <div class="timeline-panel history-panel">
                        <div class="timeline-body">
                            <p>
                                <span class="font-weight-bold text-danger">Jhon Doe</span>
                                un-assigned task
                                <span class="font-weight-bold text-purple">TID01 - Creating Account</span>
                                for Visit ID
                                <span class="font-weight-bold text-success">VID02</span>
                                on DOS
                                <span class="font-weight-bold text-purple">05/26/22</span>
                                for patient
                                <span class="font-weight-bold text-danger">PT02</span>
                                -
                                <span class="font-weight-bold text-danger">Jhon Doe</span>
                            </p>
                            <p><small style="color:grey;" class="mt-2">05-26-22 01:47 AM | <span
                                        style="color:orangered">Powers Pediatrics</span> | <span
                                        style="color:orangered">Module 01</span></small></p>
                        </div>

                    </div>
                </li>

                <li class="timeline-inverted history-li">

                    <div class="timeline-badge history-badge danger">
                        <i class="fas fa-user"></i>
                    </div>

                    <div class="timeline-panel history-panel">
                        <div class="timeline-body">
                            <p>
                                <span class="font-weight-bold text-danger">Jhon Doe</span>
                                completed task
                                <span class="font-weight-bold text-purple">TID01 - Creating Account</span>
                                for Visit ID
                                <span class="font-weight-bold text-success">VID02</span>
                                on DOS
                                <span class="font-weight-bold text-purple">05/26/22</span>
                                for patient
                                <span class="font-weight-bold text-danger">PT02</span>
                                -
                                <span class="font-weight-bold text-danger">Jhon Doe</span>
                            </p>
                            <p><small style="color:grey;" class="mt-2">05-26-22 01:47 AM | <span
                                        style="color:orangered">Powers Pediatrics</span> | <span
                                        style="color:orangered">Module 01</span></small></p>
                        </div>

                    </div>
                </li>
            </ul>
        </div>
    </Dialog>
</template>

<script>

export default {
    setup() {
        
    },
    data(){
        return{
            showModal:false,
        }
    },
    methods: {
    

    }
    
}
</script>